import { useEffect, useState } from "react";
import CreateCaseStudyForm from "./components/CreateCaseStudyForm";
import { fetchPost } from "../../services/serviceClient";
import CaseStudyCard from "./components/CaseStudyCard";
import { CaseStudyData } from "./interface/case-study";
import EditCaseStudyForm from "./components/EditCaseStudyForm";
import axios from "axios";
import { url } from "inspector";

const CaseStudy = () => {
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [caseStudy, setCaseStudy] = useState<CaseStudyData[]>([]);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [caseStudyId, setCaseStudyId] = useState<string>("");

  const getAllCaseStudy = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/case-study/get-all-case-study`,
        {
          headers: {
            "client-id": process.env.REACT_APP_MARKETING_API_CLIENT_ID,
            "client-key": process.env.REACT_APP_MARKETING_API_CLIENT_KEY,
          },
        }
      );

      // Check status (2xx)
      if (res.data.success) {
        const data = res.data.data;
        console.log("fetched case studies", data);
        setCaseStudy(data);
      } else {
        console.error(
          "Unexpected status code while fetching case studies:",
          res.status,
          res.statusText
        );
        // you may want to handle non-2xx here (e.g. show error UI)
      }
    } catch (error) {
      // error handling
      if (axios.isAxiosError(error)) {
        if (error.response) {
          // The server responded with a status outside 2xx
          console.error(
            "API responded with error status:",
            error.response.status,
            error.response.data
          );
        } else if (error.request) {
          // Request made but no response received
          console.error("No response received:", error.request);
        } else {
          // Something happened in setting up the request
          console.error("Error setting up request:", error.message);
        }
      } else {
        // Non-Axios error
        console.error("Unexpected error:", error);
      }
    }
  };

  const handleEdit = (caseStudy: CaseStudyData) => {
    setOpenEditModal(true);
    setCaseStudyId(caseStudy.id);
    // TODO: Implement edit functionality
  };
  const handleDelete = async (caseStudyId: string) => {
    const res = await fetchPost(
      `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/case-study/delete/${caseStudyId}`,
      {}
    );
    if (res.success) {
      getAllCaseStudy();
    }
  };

  useEffect(() => {
    getAllCaseStudy();
  }, []);

  return (
    <>
      <div className="p-5">
        <div className="flex flex-wrap justify-between items-end mb-2">
          <div className="">
            <h1 className="font-bold text-2xl text-gray-500">Case Study</h1>
          </div>
          <button
            onClick={() => {
              setOpenCreateModal(true);
            }}
            className="cursor-pointer text-white bg-myPrimaryColor px-3 py-1 rounded font-semibold"
          >
            Add new
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {Array.isArray(caseStudy) &&
          caseStudy.map((caseStudy: any) => (
            <CaseStudyCard
              key={caseStudy.id.toString()}
              caseStudy={caseStudy}
              onEdit={handleEdit}
              onDelete={handleDelete}
              // onView={handleView}
            />
          ))}
      </div>

      {/* Empty State */}
      {caseStudy.length === 0 && (
        <div className="text-center py-12">
          <p className="text-gray-500 text-lg">No case studies found</p>
          <p className="text-gray-400 text-sm mt-2">
            Create your first case study to get started
          </p>
        </div>
      )}

      {/* Case Study Creation Modal */}
      <CreateCaseStudyForm
        isOpen={openCreateModal}
        onClose={() => setOpenCreateModal(false)}
        getAllCaseStudy={getAllCaseStudy}
      />

      <EditCaseStudyForm
        isOpen={openEditModal}
        onClose={() => setOpenEditModal(false)}
        caseStudyId={caseStudyId.toString()}
        onUpdate={getAllCaseStudy}
      />
    </>
  );
};

export default CaseStudy;
